export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10217.1b97c896.jpg";